import RestUtilities, { IRestResponse } from "./RestUtilities";

export default class Releases {
  static async fetch(): Promise<IRestResponse<string>> {
    return await RestUtilities.get<string>("/api/Releases/release");
  }
}